<template>
  <div>
    <Widget
      ref="widget"
      :height="height"
      :model="model"
      :defaults="{ paramName: 'dashBoard.actWorkClient', filters: {} }"
      :api="api"
      @click="onClick($event)"
      :isLoading="loading"
      @loading="loading = $event"
    >
      <template v-slot:title> Акты выполненных работ </template>
    </Widget>
    <s-quickOpenDoc ref="quickOpenDoc" @onClose="itemShowClose" />
    <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" @click="onClickMenu($event)" />
  </div>
</template>

<script>
import { popupMenu, genModel } from "@/components/mixings";
export default {
  mixins: [popupMenu, genModel],
  components: {
    Widget: () => import("./widgets/apiTable"),
  },
  props: {
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      idShow: 0,
      contentHeight: 10,
      hideViewed: true,
      loading: false,
      data: [],
      showConfig: false,
      timeID: null,
      array_object: [],
      m: this.$store.getters["config/get"].models.documentActWorkClient,
    };
  },
  created() {
    this.fitchData();
  },
  computed: {
    api() {
      return this.m.api;
    },
    model() {
      return this.$store.getters["config/get"].models.dashBoard.list_actWorkClient;
    },

    minHeight() {
      let h = this.height;
      if (this.$vuetify.breakpoint.name == "xs" && this.data.length == 0) {
        h = 0;
      }
      return h;
    },
  },
  watch: {},
  methods: {
    onClick(e) {
      if (e.field?.isMenu) {
        if (["document"].includes(e.field.name)) {
          let menuItems = [
            {
              name: e.field.name,
              title: "Открыть документ",
              action: async () => {
                this.$refs.quickOpenDoc.openDocument(e.row.base_name, parseInt(e.row.doc_id), e.row);
              },
            },
          ];
          this.showPopupMenu(e.field.name, e.row, e.event, { menuItems });
        } else this.showPopupMenu(e.field.name, e.row, e.event, e);
        return;
      }
      this.idShow = e.row.id;
      this.$refs.quickOpenDoc.openDocument("AccountingDocActWorkClient", parseInt(e.row.id), e.row);
    },
    itemShowClose() {
      this.loading = true;
      let id = this.idShow;
      this.idShow = 0;
      if (id) this.$refs.widget.updateRowData(id);
      this.loading = !true;
    },

    async fitchData() {
      this.afterFitch();
    },
    afterFitch() {
      this.loading = false;
    },
  },
};
</script>
